import React from 'react'
import { Timeline, Row, Col, Typography, Divider } from 'antd';
import logo from '../../img/logo.png';
import aboutFooter from '../../img/YouthArtsCamp.jpg';
import './style.css';

const AboutGirlsLeadGirls = () => {
  const { Paragraph } = Typography;
  return (
    <>
      <Row gutter={24}>
        <Col xl={12} lg={12} md={24} sm={24} xs={24} className="about-glg">
          <img src={aboutFooter} alt="About Art Camp" srcset={aboutFooter} className="about-footer" />
        </Col>
        <Col xl={12} lg={12} md={24} sm={24} xs={24} >
          <h2>Creative Arts for Positive Mental Health</h2>
          <Paragraph className="justify-content">
             Learn how to use art as a means of self-expressions to promote positive mental health. Facilitated by
             <br/><b>Ms. Mallory Scoppa Gardner</b>, Certified Arts Educator.
             </Paragraph>
          <h3 style={{marginBottom:"15px"}}>What you will learn:</h3>
          <Timeline>
            <Timeline.Item>Using art to express feelings of stress, anxiety, depression and concepts that are difficult to express.</Timeline.Item>
            <Timeline.Item>The various manifestation of mental and physical struggles faced by individuals.</Timeline.Item>
            <Timeline.Item>Capitalizing on art-making processes to express feelings in a non-verbal fashion.</Timeline.Item>
            <Timeline.Item>Denial/Restriction to undergo higher studies outside of Puducherry</Timeline.Item>
            <Timeline.Item>How art has been used to evoke joy through historical analysis and discussion</Timeline.Item>
            <Timeline.Item>Positive mental health visualization through various artistic expressions.</Timeline.Item>
          </Timeline>
         <h3 style={{marginBottom:"15px"}}>Materials needed:</h3>
          <Timeline>
            <Timeline.Item>Paper</Timeline.Item>
            <Timeline.Item>Pencils</Timeline.Item>
            <Timeline.Item>Erasers</Timeline.Item>
            <Timeline.Item>Coloring Pencils</Timeline.Item>
            <Timeline.Item>Watercolor Paper</Timeline.Item>
            <Timeline.Item>Watercolor Brushes</Timeline.Item>
            <Timeline.Item>Watercolor Paints</Timeline.Item>
            <Timeline.Item>Laptop/Computer/Tablet/Phone</Timeline.Item>
          </Timeline>
          <h3 style={{marginBottom:"15px"}}>Benefits:</h3>
          <Timeline>
            <Timeline.Item>Improved positive mental health for participants</Timeline.Item>
            <Timeline.Item>Critical positive mental health discussions at home and communities to establish possible support systems for young people’s mental health</Timeline.Item>
            <Timeline.Item>Participants will receive a digital certificate for completing the course</Timeline.Item>
            <Timeline.Item>Artwork created by participants will be compiled and showcased online on TYCL’s website</Timeline.Item>
            <Timeline.Item>Selected artworks will be published at the end of the year </Timeline.Item>
          </Timeline>
        </Col>
      </Row>
    </>
  )
}

export default AboutGirlsLeadGirls;